import React, { useState } from 'react';

const FreeDiscussion = ({ 
    isVisible, 
    user, 
    userProfile, // نام کاربری کاربر لاگین شده
    comments,    // لیست نظرات که از App.jsx می‌آید
    isLoadingData, // وضعیت لودینگ از App.jsx
    onAddComment,  // تابع ارسال نظر از App.jsx
    isSubmitting,  // وضعیت در حال ارسال از App.jsx
    onShowAuth,    // باز کردن مودال لاگین اصلی
    Icons 
}) => {
    const [commentText, setCommentText] = useState('');
    const [selectedComment, setSelectedComment] = useState(null);

    // --- Handle Submit Comment ---
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!user) {
            onShowAuth(); // باز کردن مودال لاگین اصلی در App.jsx
            return;
        }

        if (!commentText.trim()) return;

        // فراخوانی تابع ارسال نظر در App.jsx
        onAddComment(commentText.trim());
        setCommentText('');
    };

    return (
        <>
            {/* --- Forum Page Content --- */}
            <div id="page-forum" className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
                <div className="container mx-auto px-4 py-12 pb-24 fade-in">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="h-1 w-12 bg-yellow-500 rounded-full"></div>
                        <h3 className="text-3xl font-black text-white">تالار گفت‌و‌گو</h3>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Send Message Section */}
                        <div className="lg:col-span-1">
                            <div className="bg-slate-900/60 backdrop-blur-xl border border-slate-800 p-6 rounded-3xl sticky top-24">
                                <h4 className="text-xl font-bold text-white mb-4">ارسال نظر جدید</h4>
                                <p className="text-slate-400 text-sm mb-6 leading-relaxed">
                                    نظرات، سوالات و تجربیات خود را با دیگر کاربران به اشتراک بگذارید.
                                    <br/>
                                    <span className="text-yellow-500 text-xs">(پیام‌ها پس از تایید نمایش داده می‌شوند)</span>
                                </p>

                                <form onSubmit={handleSubmit} className="space-y-4">
                                    <div>
                                        <textarea 
                                            value={commentText}
                                            onChange={(e) => setCommentText(e.target.value)}
                                            placeholder={user ? "متن پیام شما..." : "برای ارسال پیام وارد حساب شوید"}
                                            disabled={!user || isSubmitting}
                                            className="w-full bg-slate-950/50 border border-slate-800 text-white rounded-2xl p-4 min-h-[150px] focus:ring-2 focus:ring-yellow-500/50 focus:border-yellow-500 outline-none transition-all resize-none text-sm"
                                        ></textarea>
                                    </div>
                                    <button 
                                        type="submit"
                                        disabled={!user || isSubmitting || !commentText.trim()}
                                        className={`w-full py-4 rounded-2xl font-bold flex items-center justify-center gap-2 transition-all ${
                                            user 
                                            ? 'bg-yellow-500 hover:bg-yellow-400 text-slate-900 shadow-lg shadow-yellow-500/20' 
                                            : 'bg-slate-800 text-slate-500 cursor-not-allowed'
                                        }`}
                                    >
                                        {isSubmitting ? 'در حال ارسال...' : (
                                            <>
                                                <span>ارسال پیام</span>
                                                <Icons.Send size={18} />
                                            </>
                                        )}
                                    </button>
                                    {!user && (
                                        <p className="text-xs text-center text-slate-500 mt-2 cursor-pointer hover:text-yellow-500" onClick={onShowAuth}>
                                            ابتدا باید وارد حساب خود شوید (کلیک کنید)
                                        </p>
                                    )}
                                </form>
                            </div>
                        </div>

                        {/* Comments List */}
                        <div className="lg:col-span-2">
                            <div className="space-y-4">
                                {isLoadingData ? (
                                    <div className="flex flex-col items-center justify-center py-20 text-slate-500 italic">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500 mb-4"></div>
                                        <span>در حال بارگذاری نظرات...</span>
                                    </div>
                                ) : comments.length === 0 ? (
                                    <div className="bg-slate-900/40 border border-slate-800/50 p-12 rounded-3xl text-center">
                                        <Icons.MessageSquare size={48} className="mx-auto text-slate-700 mb-4 opacity-20" />
                                        <p className="text-slate-500">هنوز نظری ثبت نشده است. اولین نفر باشید!</p>
                                    </div>
                                ) : (
                                    comments.map((comment) => (
                                        <div 
                                            key={comment.id} 
                                            onClick={() => setSelectedComment(comment)}
                                            className="bg-slate-900/40 hover:bg-slate-900/60 border border-slate-800/50 p-5 rounded-3xl transition-all cursor-pointer group"
                                        >
                                            <div className="flex items-start gap-4">
                                                <div className="w-12 h-12 rounded-2xl bg-slate-800 flex items-center justify-center text-slate-400 group-hover:bg-yellow-500/10 group-hover:text-yellow-500 transition-colors">
                                                    <Icons.User size={24} />
                                                </div>
                                                <div className="flex-grow min-w-0">
                                                    <div className="flex items-center justify-between mb-1">
                                                        <h5 className="font-bold text-white truncate">{comment.name}</h5>
                                                        <span className="text-[10px] text-slate-500 bg-slate-950 px-2 py-1 rounded-lg">
                                                            {new Date(comment.created_at).toLocaleDateString('fa-IR')}
                                                        </span>
                                                    </div>
                                                    <p className="text-slate-400 text-sm line-clamp-2 leading-relaxed">
                                                        {comment.text}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* Full Comment Modal */}
                        {selectedComment && (
                            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/90 backdrop-blur-md transition-all" onClick={() => setSelectedComment(null)}>
                                <div className="bg-slate-900 border border-slate-800 w-full max-w-2xl rounded-3xl p-6 md:p-8 shadow-2xl scale-in" onClick={e => e.stopPropagation()}>
                                    <div className="flex items-center gap-4 mb-6">
                                        <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-yellow-500 flex items-center justify-center text-slate-900 font-bold shadow-lg shadow-yellow-500/20">
                                            <Icons.User size={24} className="w-5 h-5 md:w-6 md:h-6" />
                                        </div>
                                        <div className="min-w-0 flex-grow">
                                            <h3 className="text-lg md:text-xl font-bold text-white truncate">{selectedComment.name}</h3>
                                            <span className="text-xs text-slate-400">{new Date(selectedComment.created_at).toLocaleDateString('fa-IR')}</span>
                                        </div>
                                        <button onClick={() => setSelectedComment(null)} className="mr-auto text-slate-400 hover:text-red-500 transition-colors">
                                            <Icons.X size={24} />
                                        </button>
                                    </div>
                                    <div className="bg-slate-900/50 p-4 md:p-6 rounded-2xl border border-slate-800 max-h-[60vh] overflow-y-auto custom-scrollbar">
                                        <p className="text-slate-300 leading-7 md:leading-8 whitespace-pre-wrap text-justify text-xs md:text-sm break-words">
                                            {selectedComment.text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default FreeDiscussion;